{
  "en": {
    "Создать всё": "Create all",
    "Карточка для маркетплейса": "Marketplace card",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Up to 5 angles on any background: upload once for everything below",
    "Главное фото пойдёт на обложку и в видео": "The main photo goes on the cover and into the video",
    "Все стили, {0}": "All styles, {0}",
    "по {0} C за кадр": "{0} C per shot",
    "фото в сценах": "photos in scenes",
    "без надписей на фото": "no text on photos",
    "Например: мягкий свет, без реквизита": "For example: soft light, no props",
    "К фото и видео · без текста на кадрах": "For photos and video · no text on frames",
    "Название первой строкой": "Name on the first line",
    "Заполнить": "Fill in",
    "Возьмём название и короткие преимущества": "We’ll take the name and short benefits",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "For example: wireless noise-cancelling headphones. Up to 40 hours without recharging",
    "Цены и призывы не возьмём": "We won’t take prices or calls to action",
    "Не нашли название: допишите его первой строкой": "No name found: add it on the first line",
    "Те же наборы, что в «Фотосессии товара»": "The same sets as in «Product photo shoot»",
    "{0} фото в сценах": "{0} photos in scenes",
    "Набор «{0}»": "Set «{0}»",
    "3 слайда с преимуществами": "3 benefit slides",
    "со звуком": "with sound",
    "Результаты": "Results",
    "Готово всё: {0} и {1}.": "All done: {0} and {1}.",
    "Готово {0}.": "Ready: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "The bot has already sent everything to the chat, in a separate topic.",
    "Этот вариант карточки пока недоступен": "This card option is not available yet",
    "Отметьте, что сделать": "Check what to make",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Slides need 3 benefits, each on a new line",
    "Проверьте загрузку фото": "Check the photo upload",
    "Выберите, что сделать": "Choose what to make",
    "Добавьте название и преимущества": "Add a name and benefits",
    "Выберите количество фото": "Choose the number of photos",
    "Файлы ещё загружаются": "Files are still loading",
    "Фото в сценах": "Photos in scenes",
    "Набор сцен для карточки": "Scene set for the card",
    "Оформление слайдов": "Slide design",
    "Видео товара": "Product video",
    "сек": "s",
    "Как двигается товар · 5 сек": "How the product moves · 5 s",
    "описание": "description",
    "Стиль текста: заголовок, текст и ключи": "Text style: title, text and keywords",
    "Собираем карточку": "Building the card",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "You can leave the screen: the bot will send everything to the chat when it’s ready.",
    "Карточка готова": "The card is ready",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "We don’t allow other brands’ trademarks, politics or prohibited content.",
    "карточка не создана": "the card was not created",
    "Не получилось собрать карточку": "Couldn’t build the card",
    "Изменить фото или текст": "Change the photo or text",
    "Снимаем фото в сценах": "Shooting photos in scenes",
    "Монтируем видео": "Editing the video",
    "Каталог": "Catalog",
    "Белый фон и ракурсы": "White background and angles",
    "С моделью": "With a model",
    "Товар в руках и на человеке": "The product in hands and on a person",
    "Лайфстайл": "Lifestyle",
    "Стол, гостиная, кафе": "Table, living room, café",
    "Травертин и шёлк": "Travertine and silk",
    "Белый и светло-серый": "White and light grey",
    "Цветной подиум": "Colored podium",
    "Природа": "Nature",
    "Горы и вода": "Mountains and water",
    "Город": "City",
    "Улица и кафе": "Street and café",
    "Ель и гирлянды": "Fir tree and garlands",
    "Подарок": "Gift",
    "Коробка и бархат": "Box and velvet",
    "Зал и пробежка": "Gym and run",
    "Графит и подсветка": "Graphite and backlight",
    "Сцены на выбор": "Scenes of your choice",
    "Вращение": "Rotation",
    "Товар плавно поворачивается": "The product rotates smoothly",
    "Камера медленно приближается": "The camera slowly moves in",
    "Блик света": "Light glare",
    "По товару проходит мягкий блик": "A soft glare passes over the product",
    "Парение": "Floating",
    "Товар висит в воздухе и чуть покачивается": "The product hangs in the air and sways slightly",
    "Сияние": "Glow",
    "Мягкий свет и частицы вокруг": "Soft light and particles around",
    "Чистый фон и ровный свет": "Clean background and even light",
    "Отъезд камеры": "Camera pull-back",
    "Камера плавно отдаляется от товара": "The camera smoothly moves away from the product",
    "Капли воды": "Water drops",
    "Брызги и капли на свету": "Splashes and drops in the light",
    "Подиум": "Podium",
    "Товар поворачивается на подиуме": "The product turns on a podium",
    "Смена сцен": "Scene change",
    "Три сцены одна за другой": "Three scenes one after another"
  },
  "hy": {
    "Создать всё": "Ստեղծել բոլորը",
    "Карточка для маркетплейса": "Քարտ մարքեթփլեյսի համար",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Մինչև 5 տեսանկյուն ցանկացած ֆոնի վրա. վերբեռնեք մեկ անգամ ներքևում գտնվող ամեն ինչի համար",
    "Главное фото пойдёт на обложку и в видео": "Գլխավոր լուսանկարը կօգտագործվի շապիկի և տեսանյութի համար",
    "Все стили, {0}": "Բոլոր ոճերը, {0}",
    "по {0} C за кадр": "{0} C մեկ կադրի համար",
    "фото в сценах": "լուսանկարներ տեսարաններում",
    "без надписей на фото": "առանց գրությունների լուսանկարների վրա",
    "Например: мягкий свет, без реквизита": "Օրինակ՝ մեղմ լույս, առանց ռեկվիզիտի",
    "К фото и видео · без текста на кадрах": "Լուսանկարների և տեսանյութի համար · առանց տեքստի կադրերում",
    "Название первой строкой": "Անվանումը՝ առաջին տողում",
    "Заполнить": "Լրացնել",
    "Возьмём название и короткие преимущества": "Կվերցնենք անվանումը և կարճ առավելությունները",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Օրինակ՝ անլար ականջակալներ աղմուկի ճնշմամբ։ Մինչև 40 ժամ առանց լիցքավորման",
    "Цены и призывы не возьмём": "Գներն ու կոչերը չենք վերցնի",
    "Не нашли название: допишите его первой строкой": "Անվանումը չգտանք. ավելացրեք այն առաջին տողում",
    "Те же наборы, что в «Фотосессии товара»": "Նույն հավաքածուները, ինչ «Ապրանքի ֆոտոսեսիա»-ում",
    "{0} фото в сценах": "{0} լուսանկար տեսարաններում",
    "Набор «{0}»": "«{0}» հավաքածու",
    "3 слайда с преимуществами": "3 առավելությունների սլայդ",
    "со звуком": "ձայնով",
    "Результаты": "Արդյունքներ",
    "Готово всё: {0} и {1}.": "Ամեն ինչ պատրաստ է՝ {0} և {1}։",
    "Готово {0}.": "Պատրաստ է՝ {0}։",
    "Бот уже прислал всё в чат, в отдельную тему.": "Բոտն արդեն ամեն ինչ ուղարկել է չատ՝ առանձին թեմայում։",
    "Этот вариант карточки пока недоступен": "Քարտի այս տարբերակը դեռ հասանելի չէ",
    "Отметьте, что сделать": "Նշեք՝ ինչ անել",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Սլայդներին պետք է 3 առավելություն՝ յուրաքանչյուրը նոր տողից",
    "Проверьте загрузку фото": "Ստուգեք լուսանկարի վերբեռնումը",
    "Выберите, что сделать": "Ընտրեք՝ ինչ անել",
    "Добавьте название и преимущества": "Ավելացրեք անվանումն ու առավելությունները",
    "Выберите количество фото": "Ընտրեք լուսանկարների քանակը",
    "Файлы ещё загружаются": "Ֆայլերը դեռ բեռնվում են",
    "Фото в сценах": "Լուսանկարներ տեսարաններում",
    "Набор сцен для карточки": "Տեսարանների հավաքածու քարտի համար",
    "Оформление слайдов": "Սլայդների ձևավորում",
    "Видео товара": "Ապրանքի տեսանյութ",
    "сек": "վ",
    "Как двигается товар · 5 сек": "Ինչպես է շարժվում ապրանքը · 5 վ",
    "описание": "նկարագրությունը",
    "Стиль текста: заголовок, текст и ключи": "Տեքստի ոճ՝ վերնագիր, տեքստ և բանալի բառեր",
    "Собираем карточку": "Հավաքում ենք քարտը",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Կարող եք լքել էկրանը. բոտը ամեն ինչ կուղարկի չատ, երբ պատրաստ լինի։",
    "Карточка готова": "Քարտը պատրաստ է",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Մենք բաց չենք թողնում այլոց ապրանքային նշանները, քաղաքականությունն ու արգելվածը։",
    "карточка не создана": "քարտը չի ստեղծվել",
    "Не получилось собрать карточку": "Չհաջողվեց հավաքել քարտը",
    "Изменить фото или текст": "Փոխել լուսանկարը կամ տեքստը",
    "Снимаем фото в сценах": "Լուսանկարում ենք տեսարաններում",
    "Монтируем видео": "Մոնտաժում ենք տեսանյութը",
    "Каталог": "Կատալոգ",
    "Белый фон и ракурсы": "Սպիտակ ֆոն և տեսանկյուններ",
    "С моделью": "Մոդելով",
    "Товар в руках и на человеке": "Ապրանքը ձեռքերում և մարդու վրա",
    "Лайфстайл": "Լայֆսթայլ",
    "Стол, гостиная, кафе": "Սեղան, հյուրասենյակ, սրճարան",
    "Травертин и шёлк": "Տրավերտին և մետաքս",
    "Белый и светло-серый": "Սպիտակ և բաց մոխրագույն",
    "Цветной подиум": "Գունավոր պոդիում",
    "Природа": "Բնություն",
    "Горы и вода": "Լեռներ և ջուր",
    "Город": "Քաղաք",
    "Улица и кафе": "Փողոց և սրճարան",
    "Ель и гирлянды": "Եղևնի և լույսերի շարաններ",
    "Подарок": "Նվեր",
    "Коробка и бархат": "Տուփ և թավիշ",
    "Зал и пробежка": "Մարզասրահ և վազք",
    "Графит и подсветка": "Գրաֆիտ և լուսավորություն",
    "Сцены на выбор": "Տեսարաններ ձեր ընտրությամբ",
    "Вращение": "Պտույտ",
    "Товар плавно поворачивается": "Ապրանքը սահուն պտտվում է",
    "Камера медленно приближается": "Տեսախցիկը դանդաղ մոտենում է",
    "Блик света": "Լույսի փայլ",
    "По товару проходит мягкий блик": "Ապրանքի վրայով մեղմ փայլ է անցնում",
    "Парение": "Ճախրում",
    "Товар висит в воздухе и чуть покачивается": "Ապրանքը կախված է օդում և թեթևակի օրորվում է",
    "Сияние": "Շողք",
    "Мягкий свет и частицы вокруг": "Մեղմ լույս և մասնիկներ շուրջը",
    "Чистый фон и ровный свет": "Մաքուր ֆոն և հավասար լույս",
    "Отъезд камеры": "Տեսախցիկի հեռացում",
    "Камера плавно отдаляется от товара": "Տեսախցիկը սահուն հեռանում է ապրանքից",
    "Капли воды": "Ջրի կաթիլներ",
    "Брызги и капли на свету": "Ցայտեր և կաթիլներ լույսի տակ",
    "Подиум": "Պոդիում",
    "Товар поворачивается на подиуме": "Ապրանքը պտտվում է պոդիումի վրա",
    "Смена сцен": "Տեսարանների փոփոխություն",
    "Три сцены одна за другой": "Երեք տեսարան իրար հետևից"
  },
  "es": {
    "Создать всё": "Crear todo",
    "Карточка для маркетплейса": "Ficha para marketplace",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Hasta 5 ángulos con cualquier fondo: súbelas una vez para todo lo de abajo",
    "Главное фото пойдёт на обложку и в видео": "La foto principal irá a la portada y al vídeo",
    "Все стили, {0}": "Todos los estilos, {0}",
    "по {0} C за кадр": "{0} C por foto",
    "фото в сценах": "fotos en escenas",
    "без надписей на фото": "sin texto en las fotos",
    "Например: мягкий свет, без реквизита": "Por ejemplo: luz suave, sin atrezo",
    "К фото и видео · без текста на кадрах": "Para fotos y vídeo · sin texto en los fotogramas",
    "Название первой строкой": "Nombre en la primera línea",
    "Заполнить": "Rellenar",
    "Возьмём название и короткие преимущества": "Tomaremos el nombre y ventajas breves",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Por ejemplo: auriculares inalámbricos con cancelación de ruido. Hasta 40 horas sin recargar",
    "Цены и призывы не возьмём": "No tomaremos precios ni llamadas a la acción",
    "Не нашли название: допишите его первой строкой": "No encontramos el nombre: añádelo en la primera línea",
    "Те же наборы, что в «Фотосессии товара»": "Los mismos conjuntos que en «Sesión de fotos del producto»",
    "{0} фото в сценах": "{0} fotos en escenas",
    "Набор «{0}»": "Conjunto «{0}»",
    "3 слайда с преимуществами": "3 diapositivas de beneficios",
    "со звуком": "con sonido",
    "Результаты": "Resultados",
    "Готово всё: {0} и {1}.": "Todo listo: {0} y {1}.",
    "Готово {0}.": "Listo: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "El bot ya lo envió todo al chat, en un tema aparte.",
    "Этот вариант карточки пока недоступен": "Esta variante de ficha aún no está disponible",
    "Отметьте, что сделать": "Marca qué hacer",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Las diapositivas necesitan 3 ventajas, cada una en una línea nueva",
    "Проверьте загрузку фото": "Comprueba la subida de la foto",
    "Выберите, что сделать": "Elige qué hacer",
    "Добавьте название и преимущества": "Añade el nombre y las ventajas",
    "Выберите количество фото": "Elige el número de fotos",
    "Файлы ещё загружаются": "Los archivos aún se están cargando",
    "Фото в сценах": "Fotos en escenas",
    "Набор сцен для карточки": "Conjunto de escenas para la ficha",
    "Оформление слайдов": "Diseño de las diapositivas",
    "Видео товара": "Vídeo del producto",
    "сек": "s",
    "Как двигается товар · 5 сек": "Cómo se mueve el producto · 5 s",
    "описание": "descripción",
    "Стиль текста: заголовок, текст и ключи": "Estilo del texto: título, texto y palabras clave",
    "Собираем карточку": "Montando la ficha",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Puedes salir de la pantalla: el bot enviará todo al chat cuando esté listo.",
    "Карточка готова": "La ficha está lista",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "No aceptamos marcas registradas ajenas, política ni contenido prohibido.",
    "карточка не создана": "la ficha no se creó",
    "Не получилось собрать карточку": "No se pudo montar la ficha",
    "Изменить фото или текст": "Cambiar la foto o el texto",
    "Снимаем фото в сценах": "Haciendo fotos en escenas",
    "Монтируем видео": "Montando el vídeo",
    "Каталог": "Catálogo",
    "Белый фон и ракурсы": "Fondo blanco y ángulos",
    "С моделью": "Con modelo",
    "Товар в руках и на человеке": "El producto en las manos y puesto",
    "Лайфстайл": "Lifestyle",
    "Стол, гостиная, кафе": "Mesa, salón, cafetería",
    "Травертин и шёлк": "Travertino y seda",
    "Белый и светло-серый": "Blanco y gris claro",
    "Цветной подиум": "Podio de color",
    "Природа": "Naturaleza",
    "Горы и вода": "Montañas y agua",
    "Город": "Ciudad",
    "Улица и кафе": "Calle y cafetería",
    "Ель и гирлянды": "Abeto y guirnaldas",
    "Подарок": "Regalo",
    "Коробка и бархат": "Caja y terciopelo",
    "Зал и пробежка": "Gimnasio y carrera",
    "Графит и подсветка": "Grafito y retroiluminación",
    "Сцены на выбор": "Escenas a elegir",
    "Вращение": "Rotación",
    "Товар плавно поворачивается": "El producto gira suavemente",
    "Камера медленно приближается": "La cámara se acerca lentamente",
    "Блик света": "Destello de luz",
    "По товару проходит мягкий блик": "Un destello suave recorre el producto",
    "Парение": "Flotación",
    "Товар висит в воздухе и чуть покачивается": "El producto flota en el aire y se balancea un poco",
    "Сияние": "Resplandor",
    "Мягкий свет и частицы вокруг": "Luz suave y partículas alrededor",
    "Чистый фон и ровный свет": "Fondo limpio y luz uniforme",
    "Отъезд камеры": "Alejamiento de cámara",
    "Камера плавно отдаляется от товара": "La cámara se aleja suavemente del producto",
    "Капли воды": "Gotas de agua",
    "Брызги и капли на свету": "Salpicaduras y gotas a contraluz",
    "Подиум": "Podio",
    "Товар поворачивается на подиуме": "El producto gira sobre un podio",
    "Смена сцен": "Cambio de escenas",
    "Три сцены одна за другой": "Tres escenas una tras otra"
  },
  "de": {
    "Создать всё": "Alles erstellen",
    "Карточка для маркетплейса": "Marktplatz-Karte",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Bis zu 5 Ansichten auf beliebigem Hintergrund: einmal hochladen für alles darunter",
    "Главное фото пойдёт на обложку и в видео": "Das Hauptfoto kommt auf das Cover und ins Video",
    "Все стили, {0}": "Alle Stile, {0}",
    "по {0} C за кадр": "je {0} C pro Bild",
    "фото в сценах": "Fotos in Szenen",
    "без надписей на фото": "ohne Text auf Fotos",
    "Например: мягкий свет, без реквизита": "Zum Beispiel: weiches Licht, ohne Requisiten",
    "К фото и видео · без текста на кадрах": "Für Fotos und Video · ohne Text in den Bildern",
    "Название первой строкой": "Name in der ersten Zeile",
    "Заполнить": "Ausfüllen",
    "Возьмём название и короткие преимущества": "Wir übernehmen den Namen und kurze Vorteile",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Zum Beispiel: kabellose Kopfhörer mit Geräuschunterdrückung. Bis zu 40 Stunden ohne Aufladen",
    "Цены и призывы не возьмём": "Preise und Handlungsaufrufe übernehmen wir nicht",
    "Не нашли название: допишите его первой строкой": "Kein Name gefunden: Ergänzen Sie ihn in der ersten Zeile",
    "Те же наборы, что в «Фотосессии товара»": "Dieselben Sets wie im «Produktfotoshooting»",
    "{0} фото в сценах": "{0} Fotos in Szenen",
    "Набор «{0}»": "Set «{0}»",
    "3 слайда с преимуществами": "3 Vorteilsfolien",
    "со звуком": "mit Ton",
    "Результаты": "Ergebnisse",
    "Готово всё: {0} и {1}.": "Alles fertig: {0} und {1}.",
    "Готово {0}.": "Fertig: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "Der Bot hat bereits alles in den Chat geschickt, in ein eigenes Thema.",
    "Этот вариант карточки пока недоступен": "Diese Kartenvariante ist noch nicht verfügbar",
    "Отметьте, что сделать": "Wählen Sie aus, was erstellt werden soll",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Folien brauchen 3 Vorteile, jeden in einer neuen Zeile",
    "Проверьте загрузку фото": "Prüfen Sie den Foto-Upload",
    "Выберите, что сделать": "Wählen Sie, was erstellt werden soll",
    "Добавьте название и преимущества": "Fügen Sie Namen und Vorteile hinzu",
    "Выберите количество фото": "Wählen Sie die Anzahl der Fotos",
    "Файлы ещё загружаются": "Die Dateien werden noch geladen",
    "Фото в сценах": "Fotos in Szenen",
    "Набор сцен для карточки": "Szenen-Set für die Karte",
    "Оформление слайдов": "Foliendesign",
    "Видео товара": "Produktvideo",
    "сек": "s",
    "Как двигается товар · 5 сек": "Wie sich das Produkt bewegt · 5 s",
    "описание": "Beschreibung",
    "Стиль текста: заголовок, текст и ключи": "Textstil: Titel, Text und Schlagwörter",
    "Собираем карточку": "Wir erstellen die Karte",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Sie können den Bildschirm verlassen: Der Bot schickt alles in den Chat, sobald es fertig ist.",
    "Карточка готова": "Die Karte ist fertig",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Fremde Marken, Politik und Verbotenes lassen wir nicht durch.",
    "карточка не создана": "die Karte wurde nicht erstellt",
    "Не получилось собрать карточку": "Die Karte konnte nicht erstellt werden",
    "Изменить фото или текст": "Foto oder Text ändern",
    "Снимаем фото в сценах": "Wir fotografieren in Szenen",
    "Монтируем видео": "Wir schneiden das Video",
    "Каталог": "Katalog",
    "Белый фон и ракурсы": "Weißer Hintergrund und Ansichten",
    "С моделью": "Mit Model",
    "Товар в руках и на человеке": "Das Produkt in der Hand und am Körper",
    "Лайфстайл": "Lifestyle",
    "Стол, гостиная, кафе": "Tisch, Wohnzimmer, Café",
    "Травертин и шёлк": "Travertin und Seide",
    "Белый и светло-серый": "Weiß und Hellgrau",
    "Цветной подиум": "Farbiges Podest",
    "Природа": "Natur",
    "Горы и вода": "Berge und Wasser",
    "Город": "Stadt",
    "Улица и кафе": "Straße und Café",
    "Ель и гирлянды": "Tanne und Lichterketten",
    "Подарок": "Geschenk",
    "Коробка и бархат": "Schachtel und Samt",
    "Зал и пробежка": "Studio und Laufen",
    "Графит и подсветка": "Graphit und Hintergrundlicht",
    "Сцены на выбор": "Szenen nach Wahl",
    "Вращение": "Drehung",
    "Товар плавно поворачивается": "Das Produkt dreht sich sanft",
    "Камера медленно приближается": "Die Kamera fährt langsam heran",
    "Блик света": "Lichtreflex",
    "По товару проходит мягкий блик": "Ein sanfter Reflex gleitet über das Produkt",
    "Парение": "Schweben",
    "Товар висит в воздухе и чуть покачивается": "Das Produkt schwebt in der Luft und schwankt leicht",
    "Сияние": "Leuchten",
    "Мягкий свет и частицы вокруг": "Weiches Licht und Partikel ringsum",
    "Чистый фон и ровный свет": "Klarer Hintergrund und gleichmäßiges Licht",
    "Отъезд камеры": "Kamerafahrt zurück",
    "Камера плавно отдаляется от товара": "Die Kamera entfernt sich sanft vom Produkt",
    "Капли воды": "Wassertropfen",
    "Брызги и капли на свету": "Spritzer und Tropfen im Licht",
    "Подиум": "Podest",
    "Товар поворачивается на подиуме": "Das Produkt dreht sich auf einem Podest",
    "Смена сцен": "Szenenwechsel",
    "Три сцены одна за другой": "Drei Szenen nacheinander"
  },
  "fr": {
    "Создать всё": "Tout créer",
    "Карточка для маркетплейса": "Fiche pour marketplace",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Jusqu’à 5 angles sur n’importe quel fond : importez-les une fois pour tout ce qui suit",
    "Главное фото пойдёт на обложку и в видео": "La photo principale ira en couverture et dans la vidéo",
    "Все стили, {0}": "Tous les styles, {0}",
    "по {0} C за кадр": "{0} C par photo",
    "фото в сценах": "photos en scènes",
    "без надписей на фото": "sans texte sur les photos",
    "Например: мягкий свет, без реквизита": "Par exemple : lumière douce, sans accessoires",
    "К фото и видео · без текста на кадрах": "Pour les photos et la vidéo · sans texte sur les images",
    "Название первой строкой": "Nom sur la première ligne",
    "Заполнить": "Remplir",
    "Возьмём название и короткие преимущества": "Nous reprendrons le nom et de courts avantages",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Par exemple : écouteurs sans fil à réduction de bruit. Jusqu’à 40 heures sans recharge",
    "Цены и призывы не возьмём": "Nous ne reprendrons ni les prix ni les appels à l’action",
    "Не нашли название: допишите его первой строкой": "Nom introuvable : ajoutez-le sur la première ligne",
    "Те же наборы, что в «Фотосессии товара»": "Les mêmes ensembles que dans «Séance photo du produit»",
    "{0} фото в сценах": "{0} photos en scènes",
    "Набор «{0}»": "Ensemble «{0}»",
    "3 слайда с преимуществами": "3 diapositives d’avantages",
    "со звуком": "avec son",
    "Результаты": "Résultats",
    "Готово всё: {0} и {1}.": "Tout est prêt : {0} et {1}.",
    "Готово {0}.": "Prêt : {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "Le bot a déjà tout envoyé dans le chat, dans un sujet séparé.",
    "Этот вариант карточки пока недоступен": "Cette variante de fiche n’est pas encore disponible",
    "Отметьте, что сделать": "Cochez ce qu’il faut créer",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Les diapositives ont besoin de 3 avantages, chacun sur une nouvelle ligne",
    "Проверьте загрузку фото": "Vérifiez l’importation de la photo",
    "Выберите, что сделать": "Choisissez ce qu’il faut créer",
    "Добавьте название и преимущества": "Ajoutez le nom et les avantages",
    "Выберите количество фото": "Choisissez le nombre de photos",
    "Файлы ещё загружаются": "Les fichiers sont encore en cours de chargement",
    "Фото в сценах": "Photos en scènes",
    "Набор сцен для карточки": "Ensemble de scènes pour la fiche",
    "Оформление слайдов": "Design des diapositives",
    "Видео товара": "Vidéo du produit",
    "сек": "s",
    "Как двигается товар · 5 сек": "Comment le produit bouge · 5 s",
    "описание": "description",
    "Стиль текста: заголовок, текст и ключи": "Style du texte : titre, texte et mots-clés",
    "Собираем карточку": "Nous assemblons la fiche",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Vous pouvez quitter l’écran : le bot enverra tout dans le chat une fois prêt.",
    "Карточка готова": "La fiche est prête",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Nous refusons les marques d’autrui, la politique et les contenus interdits.",
    "карточка не создана": "la fiche n’a pas été créée",
    "Не получилось собрать карточку": "Impossible d’assembler la fiche",
    "Изменить фото или текст": "Modifier la photo ou le texte",
    "Снимаем фото в сценах": "Nous photographions en scènes",
    "Монтируем видео": "Nous montons la vidéo",
    "Каталог": "Catalogue",
    "Белый фон и ракурсы": "Fond blanc et angles",
    "С моделью": "Avec mannequin",
    "Товар в руках и на человеке": "Le produit en main et porté",
    "Лайфстайл": "Lifestyle",
    "Стол, гостиная, кафе": "Table, salon, café",
    "Травертин и шёлк": "Travertin et soie",
    "Белый и светло-серый": "Blanc et gris clair",
    "Цветной подиум": "Podium coloré",
    "Природа": "Nature",
    "Горы и вода": "Montagnes et eau",
    "Город": "Ville",
    "Улица и кафе": "Rue et café",
    "Ель и гирлянды": "Sapin et guirlandes",
    "Подарок": "Cadeau",
    "Коробка и бархат": "Boîte et velours",
    "Зал и пробежка": "Salle de sport et course",
    "Графит и подсветка": "Graphite et rétroéclairage",
    "Сцены на выбор": "Scènes au choix",
    "Вращение": "Rotation",
    "Товар плавно поворачивается": "Le produit tourne en douceur",
    "Камера медленно приближается": "La caméra s’approche lentement",
    "Блик света": "Reflet de lumière",
    "По товару проходит мягкий блик": "Un doux reflet passe sur le produit",
    "Парение": "Lévitation",
    "Товар висит в воздухе и чуть покачивается": "Le produit flotte dans l’air et se balance légèrement",
    "Сияние": "Éclat",
    "Мягкий свет и частицы вокруг": "Lumière douce et particules autour",
    "Чистый фон и ровный свет": "Fond épuré et lumière uniforme",
    "Отъезд камеры": "Recul de caméra",
    "Камера плавно отдаляется от товара": "La caméra s’éloigne doucement du produit",
    "Капли воды": "Gouttes d’eau",
    "Брызги и капли на свету": "Éclaboussures et gouttes dans la lumière",
    "Подиум": "Podium",
    "Товар поворачивается на подиуме": "Le produit tourne sur un podium",
    "Смена сцен": "Changement de scène",
    "Три сцены одна за другой": "Trois scènes l’une après l’autre"
  },
  "pt": {
    "Создать всё": "Criar tudo",
    "Карточка для маркетплейса": "Card para marketplace",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Até 5 ângulos em qualquer fundo: envie uma vez para tudo abaixo",
    "Главное фото пойдёт на обложку и в видео": "A foto principal vai para a capa e para o vídeo",
    "Все стили, {0}": "Todos os estilos, {0}",
    "по {0} C за кадр": "{0} C por foto",
    "фото в сценах": "fotos em cenas",
    "без надписей на фото": "sem texto nas fotos",
    "Например: мягкий свет, без реквизита": "Por exemplo: luz suave, sem objetos de cena",
    "К фото и видео · без текста на кадрах": "Para fotos e vídeo · sem texto nos quadros",
    "Название первой строкой": "Nome na primeira linha",
    "Заполнить": "Preencher",
    "Возьмём название и короткие преимущества": "Vamos pegar o nome e benefícios curtos",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Por exemplo: fones sem fio com cancelamento de ruído. Até 40 horas sem recarregar",
    "Цены и призывы не возьмём": "Não vamos pegar preços nem chamadas para ação",
    "Не нашли название: допишите его первой строкой": "Não encontramos o nome: adicione-o na primeira linha",
    "Те же наборы, что в «Фотосессии товара»": "Os mesmos conjuntos da «Sessão de fotos do produto»",
    "{0} фото в сценах": "{0} fotos em cenas",
    "Набор «{0}»": "Conjunto «{0}»",
    "3 слайда с преимуществами": "3 slides de benefícios",
    "со звуком": "com som",
    "Результаты": "Resultados",
    "Готово всё: {0} и {1}.": "Tudo pronto: {0} e {1}.",
    "Готово {0}.": "Pronto: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "O bot já enviou tudo para o chat, em um tópico separado.",
    "Этот вариант карточки пока недоступен": "Esta variante do card ainda não está disponível",
    "Отметьте, что сделать": "Marque o que fazer",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Os slides precisam de 3 benefícios, cada um em uma nova linha",
    "Проверьте загрузку фото": "Verifique o envio da foto",
    "Выберите, что сделать": "Escolha o que fazer",
    "Добавьте название и преимущества": "Adicione o nome e os benefícios",
    "Выберите количество фото": "Escolha a quantidade de fotos",
    "Файлы ещё загружаются": "Os arquivos ainda estão carregando",
    "Фото в сценах": "Fotos em cenas",
    "Набор сцен для карточки": "Conjunto de cenas para o card",
    "Оформление слайдов": "Design dos slides",
    "Видео товара": "Vídeo do produto",
    "сек": "s",
    "Как двигается товар · 5 сек": "Como o produto se move · 5 s",
    "описание": "descrição",
    "Стиль текста: заголовок, текст и ключи": "Estilo do texto: título, texto e palavras-chave",
    "Собираем карточку": "Montando o card",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Você pode sair da tela: o bot enviará tudo para o chat quando estiver pronto.",
    "Карточка готова": "O card está pronto",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Não aceitamos marcas de terceiros, política nem conteúdo proibido.",
    "карточка не создана": "o card não foi criado",
    "Не получилось собрать карточку": "Não foi possível montar o card",
    "Изменить фото или текст": "Alterar a foto ou o texto",
    "Снимаем фото в сценах": "Fotografando em cenas",
    "Монтируем видео": "Editando o vídeo",
    "Каталог": "Catálogo",
    "Белый фон и ракурсы": "Fundo branco e ângulos",
    "С моделью": "Com modelo",
    "Товар в руках и на человеке": "O produto nas mãos e em uso",
    "Лайфстайл": "Lifestyle",
    "Стол, гостиная, кафе": "Mesa, sala, café",
    "Травертин и шёлк": "Travertino e seda",
    "Белый и светло-серый": "Branco e cinza-claro",
    "Цветной подиум": "Pódio colorido",
    "Природа": "Natureza",
    "Горы и вода": "Montanhas e água",
    "Город": "Cidade",
    "Улица и кафе": "Rua e café",
    "Ель и гирлянды": "Pinheiro e luzinhas",
    "Подарок": "Presente",
    "Коробка и бархат": "Caixa e veludo",
    "Зал и пробежка": "Academia e corrida",
    "Графит и подсветка": "Grafite e luz de fundo",
    "Сцены на выбор": "Cenas à escolha",
    "Вращение": "Rotação",
    "Товар плавно поворачивается": "O produto gira suavemente",
    "Камера медленно приближается": "A câmera se aproxima lentamente",
    "Блик света": "Reflexo de luz",
    "По товару проходит мягкий блик": "Um reflexo suave passa pelo produto",
    "Парение": "Flutuação",
    "Товар висит в воздухе и чуть покачивается": "O produto paira no ar e balança levemente",
    "Сияние": "Brilho",
    "Мягкий свет и частицы вокруг": "Luz suave e partículas ao redor",
    "Чистый фон и ровный свет": "Fundo limpo e luz uniforme",
    "Отъезд камеры": "Afastamento da câmera",
    "Камера плавно отдаляется от товара": "A câmera se afasta suavemente do produto",
    "Капли воды": "Gotas de água",
    "Брызги и капли на свету": "Respingos e gotas na luz",
    "Подиум": "Pódio",
    "Товар поворачивается на подиуме": "O produto gira em um pódio",
    "Смена сцен": "Troca de cenas",
    "Три сцены одна за другой": "Três cenas uma após a outra"
  },
  "tr": {
    "Создать всё": "Hepsini oluştur",
    "Карточка для маркетплейса": "Pazaryeri kartı",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Herhangi bir arka planda 5 açıya kadar: aşağıdaki her şey için bir kez yükleyin",
    "Главное фото пойдёт на обложку и в видео": "Ana fotoğraf kapağa ve videoya gider",
    "Все стили, {0}": "Tüm stiller, {0}",
    "по {0} C за кадр": "kare başına {0} C",
    "фото в сценах": "sahnelerde fotoğraflar",
    "без надписей на фото": "fotoğraflarda yazı yok",
    "Например: мягкий свет, без реквизита": "Örneğin: yumuşak ışık, aksesuarsız",
    "К фото и видео · без текста на кадрах": "Fotoğraflar ve video için · karelerde yazı yok",
    "Название первой строкой": "İlk satırda ad",
    "Заполнить": "Doldur",
    "Возьмём название и короткие преимущества": "Adı ve kısa avantajları alacağız",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Örneğin: gürültü engellemeli kablosuz kulaklık. Şarj etmeden 40 saate kadar",
    "Цены и призывы не возьмём": "Fiyatları ve çağrıları almayacağız",
    "Не нашли название: допишите его первой строкой": "Ad bulunamadı: ilk satıra ekleyin",
    "Те же наборы, что в «Фотосессии товара»": "«Ürün çekimi» ile aynı setler",
    "{0} фото в сценах": "Sahnelerde {0} fotoğraf",
    "Набор «{0}»": "«{0}» seti",
    "3 слайда с преимуществами": "3 avantaj slaytı",
    "со звуком": "sesli",
    "Результаты": "Sonuçlar",
    "Готово всё: {0} и {1}.": "Hepsi hazır: {0} ve {1}.",
    "Готово {0}.": "Hazır: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "Bot her şeyi sohbete ayrı bir konu olarak gönderdi.",
    "Этот вариант карточки пока недоступен": "Bu kart seçeneği henüz kullanılamıyor",
    "Отметьте, что сделать": "Ne yapılacağını işaretleyin",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Slaytlar için her biri yeni satırda 3 avantaj gerekir",
    "Проверьте загрузку фото": "Fotoğraf yüklemesini kontrol edin",
    "Выберите, что сделать": "Ne yapılacağını seçin",
    "Добавьте название и преимущества": "Ad ve avantajları ekleyin",
    "Выберите количество фото": "Fotoğraf sayısını seçin",
    "Файлы ещё загружаются": "Dosyalar hâlâ yükleniyor",
    "Фото в сценах": "Sahnelerde fotoğraflar",
    "Набор сцен для карточки": "Kart için sahne seti",
    "Оформление слайдов": "Slayt tasarımı",
    "Видео товара": "Ürün videosu",
    "сек": "sn",
    "Как двигается товар · 5 сек": "Ürün nasıl hareket eder · 5 sn",
    "описание": "açıklama",
    "Стиль текста: заголовок, текст и ключи": "Metin stili: başlık, metin ve anahtar kelimeler",
    "Собираем карточку": "Kart hazırlanıyor",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Ekrandan çıkabilirsiniz: hazır olduğunda bot her şeyi sohbete gönderecek.",
    "Карточка готова": "Kart hazır",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Başkalarına ait markalara, siyasete ve yasaklı içeriğe izin vermiyoruz.",
    "карточка не создана": "kart oluşturulmadı",
    "Не получилось собрать карточку": "Kart hazırlanamadı",
    "Изменить фото или текст": "Fotoğrafı veya metni değiştir",
    "Снимаем фото в сценах": "Sahnelerde fotoğraf çekiliyor",
    "Монтируем видео": "Video kurgulanıyor",
    "Каталог": "Katalog",
    "Белый фон и ракурсы": "Beyaz arka plan ve açılar",
    "С моделью": "Modelle",
    "Товар в руках и на человеке": "Ürün elde ve üzerinde",
    "Лайфстайл": "Yaşam tarzı",
    "Стол, гостиная, кафе": "Masa, oturma odası, kafe",
    "Травертин и шёлк": "Traverten ve ipek",
    "Белый и светло-серый": "Beyaz ve açık gri",
    "Цветной подиум": "Renkli podyum",
    "Природа": "Doğa",
    "Горы и вода": "Dağlar ve su",
    "Город": "Şehir",
    "Улица и кафе": "Sokak ve kafe",
    "Ель и гирлянды": "Çam ağacı ve ışık süsleri",
    "Подарок": "Hediye",
    "Коробка и бархат": "Kutu ve kadife",
    "Зал и пробежка": "Spor salonu ve koşu",
    "Графит и подсветка": "Grafit ve arka ışık",
    "Сцены на выбор": "Seçtiğiniz sahneler",
    "Вращение": "Dönüş",
    "Товар плавно поворачивается": "Ürün yavaşça döner",
    "Камера медленно приближается": "Kamera yavaşça yaklaşır",
    "Блик света": "Işık parlaması",
    "По товару проходит мягкий блик": "Ürünün üzerinden yumuşak bir parlama geçer",
    "Парение": "Süzülme",
    "Товар висит в воздухе и чуть покачивается": "Ürün havada asılı durur ve hafifçe sallanır",
    "Сияние": "Işıltı",
    "Мягкий свет и частицы вокруг": "Yumuşak ışık ve çevrede parçacıklar",
    "Чистый фон и ровный свет": "Temiz arka plan ve eşit ışık",
    "Отъезд камеры": "Kamera uzaklaşması",
    "Камера плавно отдаляется от товара": "Kamera üründen yavaşça uzaklaşır",
    "Капли воды": "Su damlaları",
    "Брызги и капли на свету": "Işıkta su sıçramaları ve damlalar",
    "Подиум": "Podyum",
    "Товар поворачивается на подиуме": "Ürün podyumda döner",
    "Смена сцен": "Sahne değişimi",
    "Три сцены одна за другой": "Art arda üç sahne"
  },
  "kk": {
    "Создать всё": "Барлығын жасау",
    "Карточка для маркетплейса": "Маркетплейсқа арналған карточка",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "Кез келген фондағы 5 ракурсқа дейін: төмендегінің бәрі үшін бір рет жүктеңіз",
    "Главное фото пойдёт на обложку и в видео": "Негізгі фото мұқаба мен бейнеге кетеді",
    "Все стили, {0}": "Барлық стильдер, {0}",
    "по {0} C за кадр": "кадрына {0} C",
    "фото в сценах": "сахналардағы фото",
    "без надписей на фото": "фотода жазусыз",
    "Например: мягкий свет, без реквизита": "Мысалы: жұмсақ жарық, реквизитсіз",
    "К фото и видео · без текста на кадрах": "Фото мен бейнеге · кадрларда мәтінсіз",
    "Название первой строкой": "Атауы бірінші жолда",
    "Заполнить": "Толтыру",
    "Возьмём название и короткие преимущества": "Атауын және қысқа артықшылықтарын аламыз",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Мысалы: шуды басатын сымсыз құлаққап. Қайта зарядтаусыз 40 сағатқа дейін",
    "Цены и призывы не возьмём": "Бағалар мен шақыруларды алмаймыз",
    "Не нашли название: допишите его первой строкой": "Атауы табылмады: оны бірінші жолға жазыңыз",
    "Те же наборы, что в «Фотосессии товара»": "«Тауар фотосессиясы» ішіндегі жиынтықтармен бірдей",
    "{0} фото в сценах": "Сахналарда {0} фото",
    "Набор «{0}»": "«{0}» жиынтығы",
    "3 слайда с преимуществами": "3 артықшылықтар слайды",
    "со звуком": "дыбыспен",
    "Результаты": "Нәтижелер",
    "Готово всё: {0} и {1}.": "Бәрі дайын: {0} және {1}.",
    "Готово {0}.": "Дайын: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "Бот бәрін чатқа бөлек тақырыппен жіберіп қойды.",
    "Этот вариант карточки пока недоступен": "Карточканың бұл нұсқасы әзірге қолжетімсіз",
    "Отметьте, что сделать": "Не істеу керегін белгілеңіз",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Слайдтарға әрқайсысы жаңа жолдан 3 артықшылық керек",
    "Проверьте загрузку фото": "Фото жүктелуін тексеріңіз",
    "Выберите, что сделать": "Не істеу керегін таңдаңыз",
    "Добавьте название и преимущества": "Атауы мен артықшылықтарын қосыңыз",
    "Выберите количество фото": "Фото санын таңдаңыз",
    "Файлы ещё загружаются": "Файлдар әлі жүктелуде",
    "Фото в сценах": "Сахналардағы фото",
    "Набор сцен для карточки": "Карточкаға арналған сахналар жиынтығы",
    "Оформление слайдов": "Слайдтардың безендірілуі",
    "Видео товара": "Тауар бейнесі",
    "сек": "сек",
    "Как двигается товар · 5 сек": "Тауар қалай қозғалады · 5 сек",
    "описание": "сипаттама",
    "Стиль текста: заголовок, текст и ключи": "Мәтін стилі: тақырып, мәтін және кілт сөздер",
    "Собираем карточку": "Карточканы жинап жатырмыз",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Экраннан шыға беруге болады: дайын болғанда бот бәрін чатқа жібереді.",
    "Карточка готова": "Карточка дайын",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Бөтен тауар белгілерін, саясатты және тыйым салынғанды өткізбейміз.",
    "карточка не создана": "карточка жасалмады",
    "Не получилось собрать карточку": "Карточканы жинау мүмкін болмады",
    "Изменить фото или текст": "Фотоны немесе мәтінді өзгерту",
    "Снимаем фото в сценах": "Сахналарда фото түсіріп жатырмыз",
    "Монтируем видео": "Бейнені монтаждап жатырмыз",
    "Каталог": "Каталог",
    "Белый фон и ракурсы": "Ақ фон және ракурстар",
    "С моделью": "Модельмен",
    "Товар в руках и на человеке": "Тауар қолда және адамда",
    "Лайфстайл": "Лайфстайл",
    "Стол, гостиная, кафе": "Үстел, қонақ бөлме, кафе",
    "Травертин и шёлк": "Травертин және жібек",
    "Белый и светло-серый": "Ақ және ашық сұр",
    "Цветной подиум": "Түсті подиум",
    "Природа": "Табиғат",
    "Горы и вода": "Таулар мен су",
    "Город": "Қала",
    "Улица и кафе": "Көше және кафе",
    "Ель и гирлянды": "Шырша және гирляндалар",
    "Подарок": "Сыйлық",
    "Коробка и бархат": "Қорап және барқыт",
    "Зал и пробежка": "Зал және жүгіру",
    "Графит и подсветка": "Графит және жарықтандыру",
    "Сцены на выбор": "Таңдаулы сахналар",
    "Вращение": "Айналу",
    "Товар плавно поворачивается": "Тауар бірқалыпты айналады",
    "Камера медленно приближается": "Камера баяу жақындайды",
    "Блик света": "Жарық шағылысы",
    "По товару проходит мягкий блик": "Тауардың үстінен жұмсақ шағылыс өтеді",
    "Парение": "Қалықтау",
    "Товар висит в воздухе и чуть покачивается": "Тауар ауада ілініп, сәл тербеледі",
    "Сияние": "Жарқырау",
    "Мягкий свет и частицы вокруг": "Жұмсақ жарық және айналадағы бөлшектер",
    "Чистый фон и ровный свет": "Таза фон және біркелкі жарық",
    "Отъезд камеры": "Камераның алыстауы",
    "Камера плавно отдаляется от товара": "Камера тауардан бірқалыпты алыстайды",
    "Капли воды": "Су тамшылары",
    "Брызги и капли на свету": "Жарықтағы шашыраңқы тамшылар",
    "Подиум": "Подиум",
    "Товар поворачивается на подиуме": "Тауар подиумда айналады",
    "Смена сцен": "Сахналар ауысуы",
    "Три сцены одна за другой": "Бірінен соң бірі үш сахна"
  },
  "uk": {
    "Создать всё": "Створити все",
    "Карточка для маркетплейса": "Картка для маркетплейсу",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "До 5 ракурсів на будь-якому тлі: завантажте один раз для всього, що нижче",
    "Главное фото пойдёт на обложку и в видео": "Головне фото піде на обкладинку й у відео",
    "Все стили, {0}": "Усі стилі, {0}",
    "по {0} C за кадр": "по {0} C за кадр",
    "фото в сценах": "фото в сценах",
    "без надписей на фото": "без написів на фото",
    "Например: мягкий свет, без реквизита": "Наприклад: м’яке світло, без реквізиту",
    "К фото и видео · без текста на кадрах": "До фото й відео · без тексту на кадрах",
    "Название первой строкой": "Назва першим рядком",
    "Заполнить": "Заповнити",
    "Возьмём название и короткие преимущества": "Візьмемо назву й короткі переваги",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "Наприклад: бездротові навушники із шумозаглушенням. До 40 годин без підзарядки",
    "Цены и призывы не возьмём": "Ціни й заклики не візьмемо",
    "Не нашли название: допишите его первой строкой": "Назву не знайдено: допишіть її першим рядком",
    "Те же наборы, что в «Фотосессии товара»": "Ті самі набори, що й у «Фотосесії товару»",
    "{0} фото в сценах": "{0} фото в сценах",
    "Набор «{0}»": "Набір «{0}»",
    "3 слайда с преимуществами": "3 слайди з перевагами",
    "со звуком": "зі звуком",
    "Результаты": "Результати",
    "Готово всё: {0} и {1}.": "Усе готово: {0} і {1}.",
    "Готово {0}.": "Готово: {0}.",
    "Бот уже прислал всё в чат, в отдельную тему.": "Бот уже надіслав усе в чат, в окрему тему.",
    "Этот вариант карточки пока недоступен": "Цей варіант картки поки недоступний",
    "Отметьте, что сделать": "Позначте, що зробити",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "Слайдам потрібні 3 переваги, кожна з нового рядка",
    "Проверьте загрузку фото": "Перевірте завантаження фото",
    "Выберите, что сделать": "Виберіть, що зробити",
    "Добавьте название и преимущества": "Додайте назву й переваги",
    "Выберите количество фото": "Виберіть кількість фото",
    "Файлы ещё загружаются": "Файли ще завантажуються",
    "Фото в сценах": "Фото в сценах",
    "Набор сцен для карточки": "Набір сцен для картки",
    "Оформление слайдов": "Оформлення слайдів",
    "Видео товара": "Відео товару",
    "сек": "с",
    "Как двигается товар · 5 сек": "Як рухається товар · 5 с",
    "описание": "опис",
    "Стиль текста: заголовок, текст и ключи": "Стиль тексту: заголовок, текст і ключі",
    "Собираем карточку": "Збираємо картку",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "Можна піти з екрана: бот надішле все в чат, коли буде готово.",
    "Карточка готова": "Картка готова",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "Чужі товарні знаки, політику й заборонене не пропускаємо.",
    "карточка не создана": "картку не створено",
    "Не получилось собрать карточку": "Не вдалося зібрати картку",
    "Изменить фото или текст": "Змінити фото або текст",
    "Снимаем фото в сценах": "Знімаємо фото в сценах",
    "Монтируем видео": "Монтуємо відео",
    "Каталог": "Каталог",
    "Белый фон и ракурсы": "Біле тло й ракурси",
    "С моделью": "З моделлю",
    "Товар в руках и на человеке": "Товар у руках і на людині",
    "Лайфстайл": "Лайфстайл",
    "Стол, гостиная, кафе": "Стіл, вітальня, кафе",
    "Травертин и шёлк": "Травертин і шовк",
    "Белый и светло-серый": "Білий і світло-сірий",
    "Цветной подиум": "Кольоровий подіум",
    "Природа": "Природа",
    "Горы и вода": "Гори й вода",
    "Город": "Місто",
    "Улица и кафе": "Вулиця й кафе",
    "Ель и гирлянды": "Ялинка й гірлянди",
    "Подарок": "Подарунок",
    "Коробка и бархат": "Коробка й оксамит",
    "Зал и пробежка": "Зал і пробіжка",
    "Графит и подсветка": "Графіт і підсвічування",
    "Сцены на выбор": "Сцени на вибір",
    "Вращение": "Обертання",
    "Товар плавно поворачивается": "Товар плавно повертається",
    "Камера медленно приближается": "Камера повільно наближається",
    "Блик света": "Відблиск світла",
    "По товару проходит мягкий блик": "Товаром пробігає м’який відблиск",
    "Парение": "Ширяння",
    "Товар висит в воздухе и чуть покачивается": "Товар висить у повітрі й трохи погойдується",
    "Сияние": "Сяйво",
    "Мягкий свет и частицы вокруг": "М’яке світло й частинки довкола",
    "Чистый фон и ровный свет": "Чисте тло й рівне світло",
    "Отъезд камеры": "Від’їзд камери",
    "Камера плавно отдаляется от товара": "Камера плавно віддаляється від товару",
    "Капли воды": "Краплі води",
    "Брызги и капли на свету": "Бризки й краплі на світлі",
    "Подиум": "Подіум",
    "Товар поворачивается на подиуме": "Товар обертається на подіумі",
    "Смена сцен": "Зміна сцен",
    "Три сцены одна за другой": "Три сцени одна за одною"
  },
  "zh": {
    "Создать всё": "全部创建",
    "Карточка для маркетплейса": "电商平台商品卡片",
    "До 5 ракурсов на любом фоне: загрузите один раз для всего, что ниже": "任意背景，最多 5 个角度：上传一次，下方所有项目通用",
    "Главное фото пойдёт на обложку и в видео": "主照片将用于封面和视频",
    "Все стили, {0}": "全部风格，{0}",
    "по {0} C за кадр": "每张 {0} C",
    "фото в сценах": "张场景照片",
    "без надписей на фото": "照片上不带文字",
    "Например: мягкий свет, без реквизита": "例如：柔光，不要道具",
    "К фото и видео · без текста на кадрах": "用于照片和视频 · 画面不带文字",
    "Название первой строкой": "第一行写名称",
    "Заполнить": "填写",
    "Возьмём название и короткие преимущества": "我们会提取名称和简短卖点",
    "Например: беспроводные наушники с шумоподавлением. До 40 часов без подзарядки": "例如：降噪无线耳机。不充电可用 40 小时",
    "Цены и призывы не возьмём": "不采用价格和号召语",
    "Не нашли название: допишите его первой строкой": "未找到名称：请在第一行补上",
    "Те же наборы, что в «Фотосессии товара»": "与「商品写真」中的套组相同",
    "{0} фото в сценах": "{0} 张场景照片",
    "Набор «{0}»": "套组「{0}」",
    "3 слайда с преимуществами": "3 张卖点幻灯片",
    "со звуком": "带声音",
    "Результаты": "结果",
    "Готово всё: {0} и {1}.": "全部完成：{0}和{1}。",
    "Готово {0}.": "已完成：{0}。",
    "Бот уже прислал всё в чат, в отдельную тему.": "机器人已把全部内容发到聊天的单独话题中。",
    "Этот вариант карточки пока недоступен": "此商品卡片选项暂不可用",
    "Отметьте, что сделать": "勾选要制作的内容",
    "Слайдам нужно 3 преимущества, каждое с новой строки": "幻灯片需要 3 个卖点，每行一个",
    "Проверьте загрузку фото": "检查照片上传",
    "Выберите, что сделать": "选择要制作的内容",
    "Добавьте название и преимущества": "添加名称和卖点",
    "Выберите количество фото": "选择照片数量",
    "Файлы ещё загружаются": "文件仍在上传",
    "Фото в сценах": "场景照片",
    "Набор сцен для карточки": "商品卡片的场景组",
    "Оформление слайдов": "幻灯片设计",
    "Видео товара": "商品视频",
    "сек": "秒",
    "Как двигается товар · 5 сек": "商品如何运动 · 5 秒",
    "описание": "描述",
    "Стиль текста: заголовок, текст и ключи": "文字风格：标题、正文和关键词",
    "Собираем карточку": "正在生成商品卡片",
    "Можно уйти с экрана: бот пришлёт всё в чат, когда будет готово.": "可以离开此页面：完成后机器人会把全部内容发到聊天中。",
    "Карточка готова": "商品卡片已完成",
    "Чужие товарные знаки, политику и запрещённое не пропускаем.": "不接受他人商标、政治和违禁内容。",
    "карточка не создана": "商品卡片未创建",
    "Не получилось собрать карточку": "商品卡片生成失败",
    "Изменить фото или текст": "修改照片或文字",
    "Снимаем фото в сценах": "正在拍摄场景照片",
    "Монтируем видео": "正在剪辑视频",
    "Каталог": "目录",
    "Белый фон и ракурсы": "白底和多角度",
    "С моделью": "带模特",
    "Товар в руках и на человеке": "商品在手中和人身上",
    "Лайфстайл": "生活方式",
    "Стол, гостиная, кафе": "桌面、客厅、咖啡馆",
    "Травертин и шёлк": "洞石和丝绸",
    "Белый и светло-серый": "白色和浅灰色",
    "Цветной подиум": "彩色展台",
    "Природа": "自然",
    "Горы и вода": "山与水",
    "Город": "城市",
    "Улица и кафе": "街道和咖啡馆",
    "Ель и гирлянды": "冷杉和彩灯",
    "Подарок": "礼物",
    "Коробка и бархат": "礼盒和天鹅绒",
    "Зал и пробежка": "健身房和跑步",
    "Графит и подсветка": "石墨色和背光",
    "Сцены на выбор": "自选场景",
    "Вращение": "旋转",
    "Товар плавно поворачивается": "商品平稳旋转",
    "Камера медленно приближается": "镜头缓慢推近",
    "Блик света": "光泽",
    "По товару проходит мягкий блик": "一道柔和的光泽划过商品",
    "Парение": "悬浮",
    "Товар висит в воздухе и чуть покачивается": "商品悬在空中，轻轻摇晃",
    "Сияние": "光晕",
    "Мягкий свет и частицы вокруг": "柔光和周围的粒子",
    "Чистый фон и ровный свет": "干净背景和均匀光线",
    "Отъезд камеры": "镜头拉远",
    "Камера плавно отдаляется от товара": "镜头平稳地远离商品",
    "Капли воды": "水滴",
    "Брызги и капли на свету": "光线中的水花和水滴",
    "Подиум": "展台",
    "Товар поворачивается на подиуме": "商品在展台上旋转",
    "Смена сцен": "场景切换",
    "Три сцены одна за другой": "三个场景依次出现"
  }
}
